module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "md-modal modal-msg md-modal-transition",
    class: {
      'md-show': _vm.mdShow
    }
  }, [_c('div', {
    staticClass: "md-modal-inner"
  }, [_c('div', {
    staticClass: "md-top"
  }, [_c('div', {
    staticClass: "md-title"
  }), _vm._v(" "), _c('button', {
    staticClass: "md-close",
    on: {
      "click": _vm.closeModal
    }
  }, [_vm._v("Close")])]), _vm._v(" "), _c('div', {
    staticClass: "md-content"
  }, [_c('div', {
    staticClass: "confirm-tips"
  }, [_vm._t("message")], 2), _vm._v(" "), _c('div', {
    staticClass: "btn-wrap"
  }, [_vm._t("btnGroup")], 2)])])]), _vm._v(" "), (_vm.mdShow) ? _c('div', {
    staticClass: "md-overlay",
    on: {
      "click": _vm.closeModal
    }
  }) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-870b8950","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/modal.vue
// module id = 82
// module chunks = 0